export default __webpack_public_path__ + "static/media/kit.8069eff7.png";